export default function debounceUtil (func, wait) {
  let timeout

  function debounced (...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(context, args), wait)
  }

  debounced.cancel = function () {
    clearTimeout(timeout)
  }

  return debounced
}
